import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "student-group-add",
  "use": "student-group-add-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"student-group-add\"><path d=\"M0 7.5C0 11.644 3.356 15 7.5 15S15 11.644 15 7.5 11.644 0 7.5 0A7.498 7.498 0 000 7.5zm8.25.75v3h-1.5v-3h-3v-1.5h3v-3h1.5v3h3v1.5h-3z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol